import { CheckIcon, CopyIcon } from "./icons";

export default function LeadCreatedModal({ open, loanId, copied, onCopy, onContinue, onGoDashboard }) {
  if (!open) return null;
  return (
    <div className="overlay overlay--lead">
      <div className="lead-box">
        <span className="lead-box__icon">
          <CheckIcon size={30} stroke="#fff" width={3} />
        </span>
        <h3 className="lead-box__title">Lead created</h3>
        <button type="button" className="lead-box__chip" onClick={onCopy}>
          <span className="lead-box__chip-id">{loanId}</span>
          <span className={"lead-box__copy-icon" + (copied ? " lead-box__copy-icon--copied" : "")}>
            {copied ? <CheckIcon size={15} width={2.6} /> : <CopyIcon size={15} />}
          </span>
        </button>
        <p className="lead-box__body">Your Lead is created and saved automatically. Add bank and document details to keep it moving.</p>
        <button type="button" className="lead-box__continue" onClick={onContinue}>
          Continue
        </button>
        <div className="lead-box__go-dash">
          <button type="button" className="btn-link" onClick={onGoDashboard}>
            Go to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
}
